import { Box, Button, Checkbox, Divider, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite';
import { useState } from 'react'
import { useEffectOnce } from 'usehooks-ts';
import { partnerRoles } from '../../app/common/options/adminOptions';
import { withNavbar } from '../../app/layout/HOC';
import SkeltonAnimation from '../../app/layout/SkeltonAnimation';
import { SubPartnersKobHoved } from '../../app/models/partners';
import { useStore } from '../../app/stores/store';
import { adminUserStyles } from '../admin/adminUsers/adminUserStyles';
import NewT1aPartnerFormContainer from '../admin/adminUsers/NewT1aPartnerFormContainer';
import T1aPartnerForm from '../admin/forms/T1aPartnerForm';
import { koReportingContainerStyles } from '../basicUser/koreporting/reports/koReportingContainerStyles';
import SubPartnerModal from './SubPartnerModal';

const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#fcfcfc',
        fontSize: 16,
        fontWeight: 300,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontWeight: 300,
        fontStrethed: 'expanded',
    },
}));
const StyledTableRow = styled(TableRow)(() => ({

    '&:nth-of-type(odd)': {
        backgroundColor: '#DAE5F1',
    },
    '&:nth-of-type(even)': {
        backgroundColor: '#fcfcfc',
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const SubPartner = () => {
    const [showFormContainer, setShowFormContainer] = useState(false);

    const { modalStore, userStore,
        partnerStore: { loadSubPartnerKobhoved, subPartnerKobhovedsLoading, subPartnerKobhoveds, isSubPartnerSelectAll,
            subPartnerSelectAllHandler, subPartnerKobhovedCheckHandler } } = useStore();
    const { user } = userStore;

    const { openModal } = modalStore;

    useEffectOnce(() => {
        loadSubPartnerKobhoved();
    })

    const checkBoxHandler = (id: string) => {
        if (id) {
            subPartnerKobhovedCheckHandler(id);
        }
    };

    const showFormContainerHandler = () => {
        setShowFormContainer(true);
    }
    const showFormContainerCloseHandler = () => {
        setShowFormContainer(false);
    }

    return (
        <Box component='div' sx={{ mt: 20 }}>

            {subPartnerKobhoveds.length < 1 && !subPartnerKobhovedsLoading &&
                <Typography variant='h4' textAlign='center' sx={{ mt: 5, color: '#072B02' }} >No records found</Typography>}

            {user && !subPartnerKobhovedsLoading && subPartnerKobhoveds.length > 0 && !showFormContainer && (partnerRoles.includes(user.currentUserRole)) &&

                (<T1aPartnerForm showFormContainerHandler={showFormContainerHandler}
                    isChecked={subPartnerKobhoveds.some(x => x.isChecked)} />)
            }
            {subPartnerKobhovedsLoading && <SkeltonAnimation iteration={10} />}
            {!subPartnerKobhovedsLoading && subPartnerKobhoveds.length > 0 && !showFormContainer &&
                <>
                    <Divider sx={{ height: 20 }} />
                    <TableContainer component={Paper} sx={koReportingContainerStyles.table}>
                        <Table aria-label="Partner table">
                            <TableHead key={'tableKey'}>
                                <TableRow sx={{ backgroundColor: '#fcfcfc' }}>
                                    {user && (partnerRoles.includes(user.currentUserRole)) &&
                                        <StyledTableCell>
                                            <Checkbox
                                                checked={isSubPartnerSelectAll}
                                                value={isSubPartnerSelectAll}
                                                onChange={subPartnerSelectAllHandler}
                                                inputProps={{ 'aria-label': 'allControlled' }}
                                                sx={adminUserStyles.adminCheckBoxStyle}
                                            /></StyledTableCell>
                                    }
                                    <StyledTableCell>Info</StyledTableCell>
                                    <StyledTableCell>Partners</StyledTableCell>
                                    <StyledTableCell>Orders</StyledTableCell>
                                    <StyledTableCell>Partner No</StyledTableCell>
                                    <StyledTableCell>Partner Name</StyledTableCell>
                                    <StyledTableCell>Reseller No</StyledTableCell>
                                    <StyledTableCell>Reseller Name</StyledTableCell>
                                    <StyledTableCell>Customer No</StyledTableCell>
                                    <StyledTableCell>Customer Name</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {subPartnerKobhoveds.map((t1a: SubPartnersKobHoved, index) =>
                                    <StyledTableRow
                                        key={t1a.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        {user && (partnerRoles.includes(user.currentUserRole)) &&
                                            <StyledTableCell>
                                                <Checkbox
                                                    checked={t1a.isChecked}
                                                    value={t1a.isChecked}
                                                    onChange={() => checkBoxHandler(t1a.id)}
                                                    inputProps={{ 'aria-label': t1a.id }}
                                                    sx={adminUserStyles.adminCheckBoxStyle}
                                                />
                                            </StyledTableCell>
                                        }
                                        <StyledTableCell>
                                            <Button variant='text' onClick={() => openModal(<SubPartnerModal partnerData={t1a}
                                            />)}>
                                                More
                                            </Button>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.subPartners.length}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.naviLines.length}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.partnerNo}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.partnerName}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.resellerNo}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.resellerName}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.customerNo}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.customerName}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box>
                    </Box>
                </>
            }
            {!subPartnerKobhovedsLoading && showFormContainer &&
                <NewT1aPartnerFormContainer selectedKobhoveds={subPartnerKobhoveds.filter(x => x.isChecked)}
                    backBtnHandler={showFormContainerCloseHandler} />
            }
        </Box>
    )
}
const SubPartnerPage = withNavbar(observer(SubPartner));
export default SubPartnerPage;